import { convertPriceStringToNumber } from '../../util/dataLayer';
import HouseSearchListItems from '../../modules/search/store/HouseSearchListItems';
import { calculateNumberOfNights, hasInstantBooking } from '../../gtm/GTMHelpers';
import GTM from '../../gtm/GTM';
import GTMSelectItemModel from '../../gtm/models/GTMSelectItemModel';

export default abstract class TrackSearchResults {
    static readonly #searchListItems = HouseSearchListItems.getInstance();

    public static trackSelectItem(anchor: HTMLAnchorElement): void {
        const { house, index } = this.#findHouseAndIndexById(anchor);

        if (!house || index === -1) {
            return;
        }

        const listName = 'Search Results';
        const priceString = house.price.dayPrice;
        const price = convertPriceStringToNumber(priceString) ?? undefined;

        const quantity = calculateNumberOfNights({
            arrivalDate: house.price.startDate,
            departureDate: house.price.endDate
        });

        GTM.track(
            GTMSelectItemModel.parseToGTMData({
                index,
                listId: 'search_results',
                listName,
                id: house.id.toString(),
                title: house.title,
                country: house.country,
                region: house.region ?? undefined,
                department: house.department ?? undefined,
                place: house.place ?? undefined,
                discount: house.price.discountPerNight ?? undefined,
                pricePerNight: price ?? undefined,
                instantBooking: hasInstantBooking(house.features),
                quantity: quantity ?? undefined
            })
        );
    }

    static #findHouseAndIndexById(anchor: HTMLAnchorElement): {
        house: HouseSearchListItem | undefined;
        index: number;
    } {
        const card = anchor.closest<HTMLElement>('[data-house-id]');

        if (!card || !card.dataset || !card.dataset.houseId) {
            return { house: undefined, index: -1 };
        }

        const houseId = Number(card.dataset.houseId);

        if (!Number.isFinite(houseId) || houseId === 0) {
            return { house: undefined, index: -1 };
        }

        let index = -1;
        const house = this.#searchListItems.houses.find((h, i) => {
            if (h.id === houseId) {
                index = i;
                return true;
            }
            return false;
        });

        return { house, index };
    }
}
